// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__w4o0l","dragIcon":"SortableItem_dragIcon__fD6Ci","disabled":"SortableItem_disabled__37EE5"};